/** Textes légaux ProMeetService — source unique pour la page /legal/terms */
import { COMPANY, CONTACT_EMAIL, CONTACT_PHONE } from "../../config/company";

export const LEGAL_VERSION = "18 mai 2026";
export const LEGAL_JURISDICTION = "Tribunal de commerce de Paris";

export const LEGAL_NAV = [
  { id: "mentions-legales", label: "Mentions légales" },
  { id: "cgu", label: "CGU" },
  { id: "cgv", label: "CGV & abonnements" },
  { id: "missions", label: "ProMeet Missions" },
  { id: "confidentialite", label: "Confidentialité" },
  { id: "cookies", label: "Cookies" },
  { id: "securite", label: "Sécurité" },
];

export function getLegalSections(company = COMPANY) {
  const c = { ...COMPANY, ...company };
  const mail = c.email || CONTACT_EMAIL;
  const tel = c.phone || CONTACT_PHONE;
  const telLink = c.phoneTel || "";

  return {
    mentions: {
      title: "Mentions légales",
      id: "mentions-legales",
      items: [
        ["Éditeur", `${c.name} — ${c.legalForm}`],
        ["SIREN", c.siren],
        ["SIRET (siège social)", c.siret],
        ["N° TVA intracommunautaire", c.tva],
        ["Siège social", c.address],
        ["Représentant légal", c.director || "—"],
        ["Contact", `${mail}${tel ? ` — ${tel}` : ""}`],
        ["Hébergeur", `${c.hostName}, ${c.hostAddress}`],
      ],
    },
  };
}

export const PLATFORM_DESCRIPTION = `
ProMeetService est une plateforme numérique française qui met en relation des clients
et des professionnels pour la prise de rendez-vous en ligne, la gestion d'agendas,
la facturation documentaire et, pour les acteurs du secteur automobile, le module
ProMeet Missions (publication et attribution de missions B2B) ainsi que le réseau
ProMeet Partners (prestataires partenaires vérifiés).
`.trim();
